// import "js/blockly/blockly";

import { AbstractBlock } from './AbstractBlock';

export default class Category {
  blocks = [];
  name = '';
  color = '';
  secondaryColour = '';
  type = 'html';
  is_shadow = false;
  // lib = '';
  id = '';
  libs = [];
  _hasLogic = false;
  is_in_toolbox = true;

  constructor(name, color) {
    this.name = name;
    this.id = name;
    this.color = color;
    this.secondaryColour = color;
  }

  setIsShadow(value) {
    this.is_shadow = true;
    return this;
  }

  add(item) {
    this.blocks.push(item);
    return this;
  }

  notify() {
    this.blocks.forEach((block: AbstractBlock) => {
      // blockのDomを取り出す
      block.notify();
      this.libs.forEach((lib) => {
        block.setLibrary(lib);
      });
      (block as any).hasLogic = this.hasLogic;
    });
  }

  /**
   * カテゴリごとのツールボックスメニューを生成する
   * @return {[type]}                 [description]
   */
  toXml(block: any): HTMLElement {
    if (!this.is_in_toolbox) {
      return null;
    }
    let toolbox_category = document.createElement('category');
    if (this.is_shadow == true) {
      toolbox_category = document.createElement('none');
    }
    toolbox_category.setAttribute('id', this.id);
    toolbox_category.setAttribute('name', this.name);
    toolbox_category.setAttribute('colour', this.color);
    toolbox_category.setAttribute('secondaryColour', this.secondaryColour);

    this.blocks.forEach((block) => {
      // blockのDomを取り出す
      const xml = block.toXml();
      if (xml) {
        toolbox_category.appendChild(xml);
      }
    });
    return toolbox_category;
  }

  toFlatXml(block) {
    if (!this.is_in_toolbox) {
      return null;
    }
    const blockXMLList = [];
    this.blocks.forEach((block) => {
      // blockのDomを取り出す
      const xml = block.toXml();
      if (xml) {
        blockXMLList.push(xml);
      }
    });
    return blockXMLList;
  }

  setLibrary(libs: string[]): this {
    this.libs = libs;
    return this;
  }

  // setLibrary(name) {
  //   this.lib = name;
  //   return this;
  // }

  hasLogic(value): this {
    this._hasLogic = value;
    return this;
  }

  setIsInToolbox(value): this {
    this.is_in_toolbox = value;
    return this;
  }

  getAllBlocks() {
    return this.blocks;
  }
}
